import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Separator } from '../../../helperComponents';
import { useGroupItemSelection, useRenderItems } from '../hooks';
export function GroupSelectItem({ label, truncate, divider, items, mode, id, itemRef, allChildIds, selectButtonLabel, }) {
    const { indeterminate, checked, handleOnSelect } = useGroupItemSelection({
        items,
        id,
        disabled: false,
        allChildIds,
    });
    const itemsJSX = useRenderItems(items);
    return (_jsxs(_Fragment, { children: [_jsx(Separator, { label: label, truncate: truncate, divider: divider, mode: mode, selectButton: {
                    indeterminate,
                    checked,
                    itemRef,
                    onClick: handleOnSelect,
                    label: selectButtonLabel,
                } }), itemsJSX] }));
}
